import React, {useEffect, useState} from "react"

import {Button, Card, CardBody, Col, Container, Nav, NavItem, NavLink, Row} from "reactstrap"
import classnames from "classnames"

import Breadcrumbs from "../../components/Common/Breadcrumb"
import MetaTitle from "../../components/MetaTitle"
import RefundsTable from "../../components/Tables/RefundsTable"
import useRefunds from "../../hooks/useRefunds"

const styles = {
    tabStyle: {
        cursor: "pointer"
    }
}

const TABS = [
    {key: "all", label: "All"},
    {key: "requested", label: "Requested"},
    {key: "pending", label: "Pending"},
    {key: "confirmed", label: "Confirmed"},
    {key: "failed", label: "Failed"},
]

const Refunds = props => {
    const [activeTab, setActiveTab] = useState("all")
    const [page, setPage] = useState(1)
    const limit = 25
    const status = activeTab === "all" ? undefined : activeTab

    const {rows, totalRows, totalPages, isLoading, loadRefunds} = useRefunds({status, page, limit})

    useEffect(() => {
        loadRefunds()
    }, [status, page])

    const handleTabChange = tab => {
        setActiveTab(tab)
        setPage(1)
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTitle title="Refunds"/>
                <Container fluid={true}>
                    <Breadcrumbs title="Billing" breadcrumbItem="Refunds" {...props}/>
                    <Row>
                        <Col xs="12">
                            <Card>
                                <CardBody>

                                    <Nav tabs>
                                        {TABS.map(t => (
                                            <NavItem key={t.key}>
                                                <NavLink
                                                    style={styles.tabStyle}
                                                    className={classnames({active: activeTab === t.key})}
                                                    onClick={() => handleTabChange(t.key)}
                                                >
                                                    {t.label}
                                                </NavLink>
                                            </NavItem>
                                        ))}
                                    </Nav>

                                    <div className="mt-3">
                                        <RefundsTable rows={rows} loading={isLoading}/>
                                    </div>

                                    {totalPages > 1 && (
                                        <div className="d-flex justify-content-between align-items-center mt-3">
                                            <small>{totalRows} refunds total</small>
                                            <div>
                                                <Button color="secondary" size="sm" disabled={page <= 1}
                                                        onClick={() => setPage(p => p - 1)}>Prev</Button>
                                                <span className="mx-2">Page {page} / {totalPages}</span>
                                                <Button color="secondary" size="sm" disabled={page >= totalPages}
                                                        onClick={() => setPage(p => p + 1)}>Next</Button>
                                            </div>
                                        </div>
                                    )}

                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default Refunds
